import React from 'react';

import './style.sass';

import { UserCard } from './UserCard';
import { UserProfile } from 'common/types/models';

type Props = {
    users: UserProfile[],
};

export const UsersCardsList = ({ users }: Props) => {
    if (!users || !users.length) {
        return null;
    }

    return (
        <div className="users-cards-list">
            {users.map(user => (
                <UserCard
                    key={user.id}
                    userId={user.id}
                />
            ))}
        </div>
    );
};

